import { TextArea } from "@/components";
import { Flex, Text } from "@chakra-ui/react";
import { MEDIA } from "@styles/common";
import theme from "@styles/theme";
import { CompleteCatchPraiseProps } from "./completeCatchPraiseProps";

export const CompleteCatchPraise = ({ ...restProps }: CompleteCatchPraiseProps) => {
    const { orderName, orderNum, payMethod, pay_memo, roomList, couponPrice } = { ...restProps };
    const totalPrice = roomList.reduce((acc, item) => acc + item.pay_all_total, 0);
    const extractStringAfterHyphen = (input: string) => {
        const match = input.match(/-(.+)/);
        if (match) {
            return match[1];
        } else {
            return null;
        }
    };

    const { isMobile } = MEDIA();

    return (
        <Flex w="100%" flexDir="column" gap="24px">
            <Flex
                w={"100%"}
                alignItems={isMobile ? "flex-start" : "center"}
                justifyContent={"space-between"}
                flexDir={isMobile ? "column-reverse" : "row"}
                gap="16px"
            >
                <Flex gap="8px" flexDir={isMobile ? "column" : "row"}>
                    <Text fontWeight={"500"}>예약자 : {orderName}</Text>
                    <Text fontWeight={"500"}>예약번호 : {extractStringAfterHyphen(orderNum)}</Text>
                    {payMethod && <Text fontWeight={"500"}>결제수단 : {payMethod}</Text>}
                </Flex>
                <Flex
                    alignItems="center"
                    width={isMobile ? "100%" : "280px"}
                    p={isMobile ? "0" : "0 16px"}
                    boxSizing={"border-box"}
                    justifyContent={"space-between"}
                >
                    <Text>총 결제금액</Text>
                    <Flex alignItems="center" gap="4px" justifyContent={"space-between"}>
                        <Text fontSize="24px" color={theme.COLOR.pink[200]} lineHeight="1.5" fontWeight={"700"}>
                            {couponPrice ? (totalPrice - couponPrice).toLocaleString() : totalPrice.toLocaleString()}
                        </Text>
                        <Text>원</Text>
                    </Flex>
                </Flex>
            </Flex>
            <Flex flexDir={"column"} alignItems="center" fontWeight="700" fontSize={isMobile ? "12px" : "16px"}>
                {pay_memo && (
                    <TextArea
                        content={
                            /<\/?[^>]+(>|$)|\t/.test(pay_memo) ? pay_memo.replace(/<\/?[^>]+(>|$)|\t/g, "") : pay_memo
                        }
                    />
                )}
            </Flex>
        </Flex>
    );
};
